var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_link") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 1103,
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-3\\u5907\\u4EFD-4",
    transform: "translate(-856.000000, -601.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-10",
    transform: "translate(520.000000, 289.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-7\\u5907\\u4EFD-2",
    transform: "translate(30.000000, 287.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_link",
    transform: "translate(306.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.99837449,0.0138916674 C7.17763102,0.0128383347 7.34372758,0.107788681 7.4336641,0.262737063 C7.52360061,0.417685445 7.52360061,0.608896867 7.4336641,0.763845249 C7.34372758,0.918793631 7.17763102,1.01374398 6.99837449,1.01268183 C4.57207767,1.01267472 2.3846857,2.47312683 1.45617718,4.71303086 C0.527668655,6.95293489 1.04089769,9.53117948 2.75654611,11.2455319 C4.47219454,12.9598843 7.0523943,13.4727317 9.29400096,12.5449338 C11.5356076,11.617136 12.9971745,9.4314071 12.9971745,7.00695024 C12.9988044,6.73230013 13.2220808,6.51051209 13.4969442,6.51051209 C13.7718076,6.51051209 13.995084,6.73230013 13.9967138,7.00695024 C13.9967138,10.869105 10.8634427,14 6.99835692,14 C3.13327112,14 0,10.869105 0,7.00695024 C0,3.14479551 3.13327112,0.0138916674 6.99835692,0.0138916674 L6.99837449,0.0138916674 Z M13.4168021,5.33856382e-06 C13.7369082,-0.0013522208 13.9977556,0.25637574 14,0.5762341 L14,4.03432945 C13.9977556,4.35418781 13.7369082,4.61191577 13.4168021,4.61055283 C13.0966961,4.61191577 12.8358486,4.35418781 12.8336043,4.03432945 L12.8336043,2.00898724 L7.51368755,7.266062 C7.28486826,7.4907962 6.91801297,7.4907962 6.68919368,7.266062 C6.58004209,7.15854095 6.51858946,7.01177906 6.51858946,6.85862299 C6.51858946,6.70546691 6.58004209,6.55870502 6.68919368,6.45118398 L12.0500205,1.15245748 L9.91763245,1.15245748 C9.5975332,1.15382046 9.33668857,0.896103146 9.33443458,0.57625166 C9.33443458,0.257489416 9.59616806,5.33856382e-06 9.91763245,5.33856382e-06 L13.4168021,5.33856382e-06 L13.4168021,5.33856382e-06 Z",
    id: "\\u5F62\\u72B6"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLink);
export default __webpack_public_path__ + "static/media/ic_link.1f7c81931992a39734ea01d89f65f215.svg";
export { ForwardRef as ReactComponent };